"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
class AdAnalyticsDailyPerformance {
    constructor({ adVideoId, impressions, clicks, spend, mobileAppInstalls, conversions, viewThroughConversions, ctr, cpc, cpm, cpa, cpaWithViewThroughConversions, }) {
        this.toJSON = () => ({
            adVideoId: this.adVideoId,
            impressions: this.impressions.toJSON(),
            clicks: this.clicks.toJSON(),
            spend: this.spend.toJSON(),
            mobileAppInstalls: this.mobileAppInstalls.toJSON(),
            conversions: this.conversions.toJSON(),
            viewThroughConversions: this.viewThroughConversions.toJSON(),
            ctr: this.ctr.toJSON(),
            cpc: this.cpc.toJSON(),
            cpm: this.cpm.toJSON(),
            cpa: this.cpa.toJSON(),
            cpaWithViewThroughConversions: this.cpaWithViewThroughConversions.toJSON(),
        });
        this.fromJSON = (json) => {
            const { adVideoId, impressions, clicks, spend, mobileAppInstalls, conversions, viewThroughConversions, ctr, cpc, cpm, cpa, cpaWithViewThroughConversions, } = Object.assign({}, json);
            // DailyPerformanceValueにfromJSONを追加すると、
            // PerformanceReportにも影響が発生するため、isArrayだけ見るようにする
            if (typeof adVideoId !== 'string')
                throw new Error('.adVideoId must be a string');
            if (!Array.isArray(impressions))
                throw new Error('.impressions must be an array');
            if (!Array.isArray(clicks))
                throw new Error('.clicks must be an array');
            if (!Array.isArray(spend))
                throw new Error('.spend must be an array');
            if (!Array.isArray(mobileAppInstalls))
                throw new Error('.mobileAppInstalls must be an array');
            if (!Array.isArray(conversions))
                throw new Error('.conversions must be an array');
            if (!Array.isArray(viewThroughConversions))
                throw new Error('.viewThroughConversions must be an array');
            if (!Array.isArray(ctr))
                throw new Error('.ctr must be an array');
            if (!Array.isArray(cpc))
                throw new Error('.cpc must be an array');
            if (!Array.isArray(cpm))
                throw new Error('.cpm must be an array');
            if (!Array.isArray(cpa))
                throw new Error('.cpa must be an array');
            if (!Array.isArray(cpaWithViewThroughConversions))
                throw new Error('.cpaWithViewThroughConversions must be an array');
            return new AdAnalyticsDailyPerformance({
                adVideoId,
                impressions: immutable_1.List(impressions),
                clicks: immutable_1.List(clicks),
                spend: immutable_1.List(spend),
                mobileAppInstalls: immutable_1.List(mobileAppInstalls),
                conversions: immutable_1.List(conversions),
                viewThroughConversions: immutable_1.List(viewThroughConversions),
                ctr: immutable_1.List(ctr),
                cpc: immutable_1.List(cpc),
                cpm: immutable_1.List(cpm),
                cpa: immutable_1.List(cpa),
                cpaWithViewThroughConversions: immutable_1.List(cpaWithViewThroughConversions),
            });
        };
        this.adVideoId = adVideoId;
        this.impressions = impressions;
        this.clicks = clicks;
        this.spend = spend;
        this.mobileAppInstalls = mobileAppInstalls;
        this.conversions = conversions;
        this.viewThroughConversions = viewThroughConversions;
        this.ctr = ctr;
        this.cpc = cpc;
        this.cpm = cpm;
        this.cpa = cpa;
        this.cpaWithViewThroughConversions = cpaWithViewThroughConversions;
    }
}
/**
 * FIXME:
 * fromJSONのstatic版がなかったので、破壊的変更を考慮して急遽追加.
 * 本来はfromJSONをstaticにすべき.
 */
AdAnalyticsDailyPerformance.sfromJSON = (json) => {
    const { adVideoId, impressions, clicks, spend, mobileAppInstalls, conversions, viewThroughConversions, ctr, cpc, cpm, cpa, cpaWithViewThroughConversions, } = Object.assign({}, json);
    // DailyPerformanceValueにfromJSONを追加すると、
    // PerformanceReportにも影響が発生するため、isArrayだけ見るようにする
    if (typeof adVideoId !== 'string')
        throw new Error('.adVideoId must be a string');
    if (!Array.isArray(impressions))
        throw new Error('.impressions must be an array');
    if (!Array.isArray(clicks))
        throw new Error('.clicks must be an array');
    if (!Array.isArray(spend))
        throw new Error('.spend must be an array');
    if (!Array.isArray(mobileAppInstalls))
        throw new Error('.mobileAppInstalls must be an array');
    if (!Array.isArray(conversions))
        throw new Error('.conversions must be an array');
    if (!Array.isArray(viewThroughConversions))
        throw new Error('.viewThroughConversions must be an array');
    if (!Array.isArray(ctr))
        throw new Error('.ctr must be an array');
    if (!Array.isArray(cpc))
        throw new Error('.cpc must be an array');
    if (!Array.isArray(cpm))
        throw new Error('.cpm must be an array');
    if (!Array.isArray(cpa))
        throw new Error('.cpa must be an array');
    if (!Array.isArray(cpaWithViewThroughConversions))
        throw new Error('.cpaWithViewThroughConversions must be an array');
    return new AdAnalyticsDailyPerformance({
        adVideoId,
        impressions: immutable_1.List(impressions),
        clicks: immutable_1.List(clicks),
        spend: immutable_1.List(spend),
        mobileAppInstalls: immutable_1.List(mobileAppInstalls),
        conversions: immutable_1.List(conversions),
        viewThroughConversions: immutable_1.List(viewThroughConversions),
        ctr: immutable_1.List(ctr),
        cpc: immutable_1.List(cpc),
        cpm: immutable_1.List(cpm),
        cpa: immutable_1.List(cpa),
        cpaWithViewThroughConversions: immutable_1.List(cpaWithViewThroughConversions),
    });
};
exports.default = AdAnalyticsDailyPerformance;
